import React from 'react';

/**
 * Telemundo Al Dia logo component for Live Video Embed.
 */
export function LiveVideoEmbedTelemundoAlDiaLogo() {
  return (
    <svg
      data-testid="TelemundoAlDiaLogo"
      className="live-video-embed__logo-svg"
      version="1.1"
      id="svg1"
      width="1935.4"
      height="525.38666"
      viewBox="0 0 1935.4 525.38666"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs id="defs1" />
      <g
        id="g1"
      >
        <g
          id="group-R5"
        >
          <path
            id="path2"
            d="M 3743.05,3940.39 H 3144.7 c -472.5,0 -906.8,-163.31 -1249.76,-436.44 -342.95,273.13 -777.25,436.44 -1249.752,436.44 H 46.8438 c -25.8711,0 -46.83989375,-20.98 -46.83989375,-46.84 V 2510.47 c 0,-25.87 20.96879375,-46.84 46.83989375,-46.84 H 1136.96 V 46.9297 c 0,-31.2109 29.96,-53.64845 59.98,-45.07814 C 1454.47,75.3086 1690.9,198.859 1894.94,361.371 2099,198.859 2335.42,75.3086 2592.96,1.85156 c 30.01,-8.57031 59.96,13.86724 59.96,45.07814 V 2463.63 h 1090.13 c 25.87,0 46.84,20.97 46.84,46.84 v 1383.08 c 0,25.86 -20.97,46.84 -46.84,46.84"
            style={{
              fill: '#ea1c24',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            transform="matrix(0.13333333,0,0,-0.13333333,0,525.38667)"
          />
          <path
            id="path3"
            d="M 1136.96,1932.66 V 46.9297 c 0,-31.2109 29.96,-53.64845 59.98,-45.07814 257.53,73.45704 493.96,197.00744 698,359.51944 -461.86,367.84 -757.98,934.949 -757.98,1571.289 z m 0,0 v 530.97 H 46.8438 c -25.8711,0 -46.83989375,20.97 -46.83989375,46.84 v 1383.08 c 0,25.86 20.96879375,46.84 46.83989375,46.84 H 645.188 c 472.502,0 906.802,-163.31 1249.752,-436.44 -461.86,-367.84 -757.98,-934.96 -757.98,-1571.29"
            style={{
              fill: '#8f191e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            transform="matrix(0.13333333,0,0,-0.13333333,0,525.38667)"
          />
          <path
            id="path4"
            d="m 1894.94,361.371 c -461.86,367.84 -757.98,934.949 -757.98,1571.289 0,636.33 296.12,1203.45 757.98,1571.29 461.87,-367.84 757.98,-934.96 757.98,-1571.29 0,-636.34 -296.11,-1203.449 -757.98,-1571.289"
            style={{
              fill: '#c41e25',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            transform="matrix(0.13333333,0,0,-0.13333333,0,525.38667)"
          />
          <path
            id="path5"
            d="m 5929.88,2594.81 -296.5,-928.62 h 583.24 z M 6487.06,806 6301.33,1340.36 H 5548.66 L 5369.45,806 h -443.13 l 755.93,2150.5 c 69.49,30.39 156.4,45.61 260.67,45.61 160.72,0 262.8,-67.35 306.28,-202.02 L 6949.74,806 h -462.68"
            style={{
              fill: '#100f0d',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            transform="matrix(0.13333333,0,0,-0.13333333,0,525.38667)"
          />
          <path
            id="path6"
            d="m 7676.34,1167.67 h 635.37 c 175.94,0 263.93,-77.13 263.93,-231.338 0,-78.203 -2.19,-121.684 -6.53,-130.332 H 7226.69 v 2179.82 c 69.49,10.84 121.62,16.29 156.39,16.29 95.56,0 168.32,-21.74 218.32,-65.17 49.94,-43.47 74.94,-106.45 74.94,-188.98 V 1167.67"
            style={{
              fill: '#100f0d',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            transform="matrix(0.13333333,0,0,-0.13333333,0,525.38667)"
          />
          <path
            id="path7"
            d="m 10895.5,1926.86 c 0,247.63 -52.1,431.72 -156.4,552.29 -104.2,120.56 -262.8,180.83 -475.7,180.83 -60.8,0 -126,-3.25 -195.5,-9.77 V 1148.13 h 179.2 c 223.7,0 387.8,61.9 492,185.72 104.3,123.81 156.4,321.45 156.4,593.01 z m 456.2,6.52 c 0,-230.27 -42.4,-431.22 -127.1,-602.79 -84.7,-171.62 -204.7,-301.96 -360,-391 C 10709.2,850.492 10525.1,806 10312.3,806 h -694.04 v 2163.52 c 202.02,26.07 406.14,39.11 612.54,39.11 371.5,0 651.1,-90.17 839,-270.45 187.9,-180.33 281.9,-448.58 281.9,-804.8"
            style={{
              fill: '#100f0d',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            transform="matrix(0.13333333,0,0,-0.13333333,0,525.38667)"
          />
          <path
            id="path8"
            d="m 12133.7,3223.67 c -58.7,-34.77 -109.7,-52.13 -153.2,-52.13 -65.1,0 -132.5,39.1 -202,117.3 l 361.7,293.25 c 63,49.94 118.4,74.94 166.2,74.94 84.7,0 164,-58.65 237.8,-175.94 z m -365,-237.85 c 69.5,10.84 121.7,16.29 156.4,16.29 193.3,0 290,-84.72 290,-254.15 V 806 h -446.4 v 2179.82"
            style={{
              fill: '#100f0d',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            transform="matrix(0.13333333,0,0,-0.13333333,0,525.38667)"
          />
          <path
            id="path9"
            d="m 13495.6,2594.81 -296.5,-928.62 h 583.3 z M 14052.8,806 l -185.7,534.36 h -752.7 L 12935.2,806 h -443.1 l 755.9,2150.5 c 69.5,30.39 156.4,45.61 260.7,45.61 160.7,0 262.8,-67.35 306.3,-202.02 L 14515.5,806 h -462.7"
            style={{
              fill: '#100f0d',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            transform="matrix(0.13333333,0,0,-0.13333333,0,525.38667)"
          />
        </g>
      </g>
    </svg>
  );
}
